/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useReportsService} from "../../../../../services/reportsService";

/* Components */
import { ReactComponent as DownloadIcon } from "../../../../../resources/images/download-02.svg";
import SelectBookingDates from "../../../../selectBookingDates";
import UCButton from "../../../../buttons";

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../../../constants/colors";

const messages = defineMessages({
  yearToDateLabel: {
    id: "bookings.filters.yearToDate"
  },
   downloadAwardsCSV: {
    id: "receipts.button"
  }
})

const MileageFilters = ({gridOptions, setGridOptions, enableDownloadButton}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const intl = useIntl();

  const { downloadMileage } = useReportsService();
  const [showMileageOverlay, setShowMileageOverlay] = useState(false)

  const handleDownload = () => {
    downloadMileage(gridOptions)
  }

  return (
    <div className={classes.filters}>
      <div className={classes.filterButtons}>
        <div className={classes.filterText}>
          <p><FormattedMessage id="bookings.filters.travelDate"/></p>
          <SelectBookingDates 
            gridOptions={gridOptions} 
            setGridOptions={setGridOptions} 
            defaultText={intl.formatMessage(messages.yearToDateLabel)}
            defaultValue={"yearToDate"}
            id={"travel"} 
            showOverlay={showMileageOverlay}
            setShowOverlay={setShowMileageOverlay}
            />
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <UCButton
          type="primary"
          className={classes.button}
          onClick={handleDownload}
          text={<FormattedMessage id="receipts.button"/>}
          icon={<DownloadIcon />}
          ariaLabel={intl.formatMessage(messages.downloadAwardsCSV)}
          tabIndex={0}
          disabled={!enableDownloadButton}
          spinner={{
            name: "downloadMileageSpinner",
            size: 20,
          }}
        />
      </div>
    </div>
  )
}

export default MileageFilters;
